import React from 'react';

import { Helmet } from 'react-helmet-async';

import { HOMEPAGE_HREF_LANGS } from 'config/routes-l10n';

export const HrefLangsHomepage: React.FC = () => {
	return (
		<Helmet>
			<link rel="alternate" hrefLang="en-US" href="https://www.change.org/" />
			{HOMEPAGE_HREF_LANGS.map(({ hrefLang, slug }) => {
				// Skip en-US as it is best practice primary market first
				if (hrefLang === 'en-US') return null;

				return <link key={hrefLang} rel="alternate" hrefLang={hrefLang} href={`https://www.change.org/${slug}`} />;
			})}
			<link rel="alternate" hrefLang="x-default" href="https://www.change.org/" />
		</Helmet>
	);
};
